export default {
  'menu.visualization.multiDimensionDataAnalysis': '订单分析',
  'multiDAnalysis.card.title.orderAnalytics': '订单分析',
  'multiDAnalysis.orderAnalytics.merchantId': 'merchantId',
  'multiDAnalysis.orderAnalytics.merchantIdPlaceholder': '商户ID',
  'multiDAnalysis.orderAnalytics.shopId': 'shopId',
  'multiDAnalysis.orderAnalytics.shopIdPlaceholder': '单店铺ID',
  'multiDAnalysis.orderAnalytics.shopIds': 'shopIds',
  'multiDAnalysis.orderAnalytics.shopIdsPlaceholder': '多个店铺ID（逗号分隔）',
  'multiDAnalysis.orderAnalytics.start': 'start',
  'multiDAnalysis.orderAnalytics.end': 'end',
  'multiDAnalysis.orderAnalytics.tzOffsetMinutes': 'tzOffsetMinutes',
  'multiDAnalysis.orderAnalytics.groupBy': 'groupBy',
  'multiDAnalysis.orderAnalytics.query': '查询',
  'multiDAnalysis.orderAnalytics.reset': '重置',
};
